import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">热门话题</h2>
          <p className="section-subtitle">全网吃瓜群众正在围观这些热门事件</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              {item.tag && (
                <span className={`text-xs font-bold px-1.5 py-0.5 rounded ${
                  item.tag === '爆'
                    ? 'bg-primary-500 text-white'
                    : item.tag === '热'
                    ? 'bg-accent-500 text-white'
                    : 'bg-secondary-400 text-white'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800">{item.name}</span>
              <span className="text-xs text-foreground-500 flex items-center gap-0.5">
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                ) : (
                  <i className="ri-arrow-down-line text-xs text-foreground-400"></i>
                )}
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}